import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import {  Grid } from '@material-ui/core';

import FeeTotal from '../../../../models/FeeTotal';
import AddServicesUnits from '../../../../models/AddServicesUnits';

import storageStyles from './storage.module.css';
import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

import { formatCurrency } from '../../../../utils/currencyFormatter';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({


});

interface StorageProps {
  classes: any;
  serviceDetails: AddServicesUnits;
  arrivalDate: string;
  pickupDate: string;
  total: number;
  calculations: FeeTotal;
  cartItemWeight: number;
  handleChange: any;
  additionalInformation: string;
};

const storage = (props: StorageProps) => {

  const { classes, serviceDetails, arrivalDate, pickupDate, total, calculations, cartItemWeight, handleChange, additionalInformation } = props;

  let minCostIsPerDay = serviceDetails.min_cost_per_day_usd != null;
  let minCost = minCostIsPerDay? serviceDetails.min_cost_per_day_usd: serviceDetails.min_cost_usd;

  return (
    <FormControl fullWidth={ true }>
      
      <Grid container className={ commonAddServiceStyles.gridContainer }>
        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }>AWB Received Date </label>
          <TextField
            disabled
            value={ arrivalDate }
            label=""
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }> Scheduled Pick Up </label>
          <TextField
            disabled
            value={ pickupDate }
            label=""
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }> Storage Days </label>
          <TextField
            disabled
            label=""
            value={ calculations.days }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }> Cost per Unit </label>
          <TextField
            disabled
            label=""
            defaultValue={ formatCurrency(serviceDetails ? serviceDetails.cost_per_storage_unit_per_day_usd : 0, 2, '$') + ` / ${serviceDetails.storage_divisor} KG` }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
         <label className={ commonStyles.inputLabel }> Total AWB weight </label>
          <TextField
            disabled
            value={ cartItemWeight }
            label=""
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }> Calculated Total Cost </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(calculations.storage_fee ? calculations.storage_fee : 0, 2, '$') }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }>{"MIN Cost per Unit" + (minCostIsPerDay? " Per Day": "")} </label>
          <TextField
            disabled
            label=""
            defaultValue={ formatCurrency(minCost ? minCost : 0, 2, '$') + ' / AWB' + (minCostIsPerDay? " / Day": "") }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>
        
        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <label className={ commonStyles.inputLabel }> MIN Storage Cost </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(calculations.total_min_cost_usd ? calculations.total_min_cost_usd : 0, 2, '$') }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}  
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
            fullWidth
          />
        </Grid>

        <Grid item sm={8} xs={6} direction="row" className={ `${ commonAddServiceStyles.gridItem } ${ commonStyles.fvMiddle }  ${ commonStyles.pb0 }` }>
          <div className={ storageStyles.horizontalLine }></div>
        </Grid>

        <Grid item sm={4} xs={6} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }>  Total Cost </label>
            <TextField
              disabled
              label=""
              value={ formatCurrency(total, 2, '$') }
              variant="outlined"
              inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }}  
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </div>
        </Grid>
        
        <Grid item sm={12} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ storageStyles.addInfoWrapper }>
            <div className={ commonStyles.inputLabelWrapper } >
              <label className={ commonStyles.inputLabel }> Additional information to GHA  </label>
              <TextField
                fullWidth={ true }
                id="outlined-disabled"
                label=""
                variant="outlined"
                onChange={ (event) => props.handleChange(event, 'additionalInformation') }
                value={ additionalInformation }
                inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                              style: { padding: TEXT_FIELD_PADDINGS }
                            }} 
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        </Grid>
      </Grid> 

    </FormControl>
  );
}

export default withStyles(styles)(storage);